import { ERROR, PENDING, SUCCESS } from "../globalStatuses/globalStatuses";
import campaignTypes from "./campaignTypes";

const initialState = {
    list: [],
    stats: {},
    listStatus: null,
    detail: null,
    detailStatus: null,
    recipients: [],
    recipientsStatus: null,
    templates: [],
    templatesStatus: null,
    analytics: null,
    analyticsStatus: null,
    actionStatus: null,
    error: null,
};

export default function campaignReducer(state = initialState, action) {
    switch (action.type) {
        case campaignTypes.LIST_PENDING:
            return { ...state, listStatus: PENDING, error: null };
        case campaignTypes.LIST_SUCCESS: {
            const items = action.payload?.items;
            const list = Array.isArray(items)
                ? items
                : Array.isArray(action.payload)
                ? action.payload
                : [];
            const stats = action.payload?.stats || {};
            return { ...state, listStatus: SUCCESS, list, stats };
        }
        case campaignTypes.LIST_ERROR:
            return { ...state, listStatus: ERROR, error: action.error };

        case campaignTypes.DETAIL_PENDING:
            return { ...state, detailStatus: PENDING };
        case campaignTypes.DETAIL_SUCCESS:
            return { ...state, detailStatus: SUCCESS, detail: action.payload };
        case campaignTypes.DETAIL_ERROR:
            return { ...state, detailStatus: ERROR, error: action.error };

        case campaignTypes.RECIPIENTS_PENDING:
            return { ...state, recipientsStatus: PENDING };
        case campaignTypes.RECIPIENTS_SUCCESS:
            return { ...state, recipientsStatus: SUCCESS, recipients: action.payload?.items || [] };
        case campaignTypes.RECIPIENTS_ERROR:
            return { ...state, recipientsStatus: ERROR, error: action.error };

        case campaignTypes.TEMPLATES_PENDING:
            return { ...state, templatesStatus: PENDING };
        case campaignTypes.TEMPLATES_SUCCESS:
            return { ...state, templatesStatus: SUCCESS, templates: action.payload?.templates || [] };
        case campaignTypes.TEMPLATES_ERROR:
            return { ...state, templatesStatus: ERROR, error: action.error };

        case campaignTypes.ANALYTICS_PENDING:
            return { ...state, analyticsStatus: PENDING };
        case campaignTypes.ANALYTICS_SUCCESS:
            return { ...state, analyticsStatus: SUCCESS, analytics: action.payload };
        case campaignTypes.ANALYTICS_ERROR:
            return { ...state, analyticsStatus: ERROR, error: action.error };

        case campaignTypes.CREATE_PENDING:
        case campaignTypes.PAUSE_PENDING:
        case campaignTypes.RESUME_PENDING:
        case campaignTypes.CANCEL_PENDING:
            return { ...state, actionStatus: PENDING };
        case campaignTypes.CREATE_SUCCESS:
        case campaignTypes.PAUSE_SUCCESS:
        case campaignTypes.RESUME_SUCCESS:
        case campaignTypes.CANCEL_SUCCESS:
            return { ...state, actionStatus: SUCCESS };
        case campaignTypes.CREATE_ERROR:
        case campaignTypes.PAUSE_ERROR:
        case campaignTypes.RESUME_ERROR:
        case campaignTypes.CANCEL_ERROR:
            return { ...state, actionStatus: ERROR, error: action.error };

        default:
            return state;
    }
}
